import logoIcon from "logo.svg";
import DashboardFlexRow from "_components/DashboardFlexRow";
import StoreMap from "_components/StoreMap";
import DeliveryProgress from "_components/DeliveryProgress";
import {
  Spin,
  Space,
  Input,
  Row,
  Col,
  Tag,
  Card,
  Table,
  Tooltip as AntdTooltip,
} from "antd";

import { Bar, Line, Doughnut } from "react-chartjs-2";
import { Auth } from "_helpers";
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import moment from "moment";
import Page from "_components/Page";
import {
  materialRequestService,
  reportService,
  stockClassificationService,
  materialDetailService,
  companyService,
  dashboardService,
  purchaseOrderService,
} from "_services";
import "../../../layouts/layout.scss";
import WidgetCard from "_components/WidgetCard";
import { FaTruck, FaWarehouse, FaUsers, FaChartLine } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import PurchaseOrderProcessChart from "_components/PurchaseOrderProcessChart";
import { set } from "lodash";
import PurchaseOrderProcessTable from "_components/PurchaseOrderProcessTable";
import StandardTable, {
  createStatusColumn,
  createProgressColumn,
} from "_components/StandardTable";
import TopCustomersGrid from "./TopCustomersGrid";
import ReactApexChart from "react-apexcharts";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// Helper: Aggregate bin data into summary by stockClassName
function aggregateStockClassSummary(data) {
  const summaryMap = {};
  data.forEach((item) => {
    const className = item.stockClassName || "UNKNOWN";
    if (!summaryMap[className]) {
      summaryMap[className] = {
        stockClassName: className,
        totalItems: 0,
        sumAgeLt90: 0,
        sumAge90To180: 0,
        sumAge180To270: 0,
        sumAge270To360: 0,
        sumAgeGt360: 0,
      };
    }
    summaryMap[className].totalItems += item.totalItems || 0;
    summaryMap[className].sumAgeLt90 += item.ageLt90 || 0;
    summaryMap[className].sumAge90To180 += item.age90To180 || 0;
    summaryMap[className].sumAge180To270 += item.age180To270 || 0;
    summaryMap[className].sumAge270To360 += item.age270To360 || 0;
    summaryMap[className].sumAgeGt360 += item.ageGt360 || 0;
  });
  return Object.values(summaryMap);
}

// Mapping from materialType code to human-readable label
const materialTypeLabels = {
  705992: "FINISHED GOOD",
  // Add more mappings as needed
};

function bucketAgesByClass(data) {
  const summaryMap = {};
  data.forEach((item) => {
    const className =
      materialTypeLabels[item.materialType] || item.materialType || "UNKNOWN";
    if (!summaryMap[className]) {
      summaryMap[className] = {
        stockClassName: className,
        ageLt90: 0,
        age90To180: 0,
        age180To270: 0,
        age270To360: 0,
        ageGt360: 0,
      };
    }
    if (typeof item.days === "number") {
      if (item.days < 90) summaryMap[className].ageLt90 += 1;
      else if (item.days < 180) summaryMap[className].age90To180 += 1;
      else if (item.days < 270) summaryMap[className].age180To270 += 1;
      else if (item.days < 360) summaryMap[className].age270To360 += 1;
      else summaryMap[className].ageGt360 += 1;
    }
  });
  return Object.values(summaryMap);
}

const stockClassSummary = [];

function Home() {
  const [loading, setLoading] = useState(false);
  const [loadingStockClasses, setLoadingStockClasses] = useState(false);
  const [stockClasses, setStockClasses] = useState([]);
  const [loadingPendingMRNs, setLoadingPendingMRNs] = useState(false);
  const [pendingMRNs, setPendingMRNs] = useState([]);
  const [error, setError] = useState(null);
  const [warehouseSummary, setWarehouseSummary] = useState({});
  const { Search } = Input;
  const [lowStockItems, setLowStockItems] = useState([]);

  const [fastMovingRMItems, setFastMovingRMItems] = useState([]);
  const [fastMovingRMItemsLoading, setFastMovingRMItemsLoading] =
    useState(false);

  const [fastMovingFGItems, setFastMovingFGItems] = useState([]);
  const [fastMovingFGItemsLoading, setFastMovingFGItemsLoading] =
    useState(false);

  const [purchaseOrderRecords, setPurchaseOrderRecords] = useState([]);
  const [purchaseOrderRecordsLoading, setPurchaseOrderRecordsLoading] =
    useState(false);
  const [topTenCustomers, setTopTenCustomers] = useState([]);
  const [topTenCustomersLoading, setTopTenCustomersLoading] = useState(false);
  const [deliveryProgressRMData, setDeliveryProgressRMData] = useState([]);
  const [deliveryProgressRMLoading, setDeliveryProgressRMLoading] =
    useState(false);
  const [deliveryProgressFGData, setDeliveryProgressFGData] = useState([]);
  const [deliveryProgressFGLoading, setDeliveryProgressFGLoading] =
    useState(false);
  const [stockChartData, setStockChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [utilizationData, setUtilizationData] = useState({
    labels: [],
    datasets: [],
  });
  const [movementChartFGData, setMovementChartFGData] = useState({
    labels: [],
    datasets: [],
  });

  const [loadingMovementChartFGData, setLoadingMovementChartFGData] =
    useState(false);

  const [movementChartRMData, setMovementChartRMData] = useState({
    labels: [],
    datasets: [],
  });

  const [loadingMovementChartRMData, setLoadingMovementChartRMData] =
    useState(false);
  const [recentActivities, setRecentActivities] = useState([]);

  // New state for aging data
  const [agingData, setAgingData] = useState([]);
  const [loadingAgingData, setLoadingAgingData] = useState(false);

  const [fgClassId, setFgClassId] = useState(
    "c1c4a193b143f4db85e64f269b7c0313"
  );
  const [rmClassId, setRmClassId] = useState(
    "2b6f7be6a3381565782842d0f7fe7f29"
  );

  // Function to load aging data from API
  const loadAgingData = () => {
    setLoadingAgingData(true);
    dashboardService
      .getAgingAqua()
      .then((data) => {
        if (data && data.content) {
          setAgingData(data.content);
        } else {
          setAgingData([]);
        }
        setLoadingAgingData(false);
      })
      .catch((error) => {
        setError(error);
        setAgingData([]);
        setLoadingAgingData(false);
      });
  };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        display: true,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            // Current value (y-value)
            let label = `${context.dataset.label || ""}: ${
              context.formattedValue
            }`;

            // Example: Add extra values (e.g., percentage or custom data)
            const extraData = context.dataset.extraValues
              ? context.dataset.extraValues[context.dataIndex]
              : null;

            if (extraData !== null) {
              label += ` (Extra: ${extraData})`;
            }

            // Add invoice number if available
            const invoiceNumber = context.dataset.extraInvoiceNumbers
              ? context.dataset.extraInvoiceNumbers[context.dataIndex]
              : null;
            if (invoiceNumber) {
              label += ` | Invoice: ${invoiceNumber}`;
            }

            return label;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#fff",
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
      y: {
        ticks: {
          color: "#fff",
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    layout: {
      padding: {
        top: 8,
        bottom: 8,
        left: 8,
        right: 8,
      },
    },
    elements: {
      line: {
        borderWidth: 2,
      },
      point: {
        radius: 3,
      },
    },
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        display: true,
        labels: {
          color: "#fff",
          padding: 8,
        },
      },
      title: {
        display: false,
      },
    },
    layout: {
      padding: {
        top: 8,
        bottom: 8,
        left: 8,
        right: 8,
      },
    },
  };

  useEffect(() => {
    setLoadingStockClasses(true);
    stockClassificationService
      .getSuggestion()
      .then((data) => {
        setStockClasses(data.content);
        setLoadingStockClasses(false);
      })
      .catch((error) => {
        setLoadingStockClasses(false);
        setError(error);
      });

    // Load aging data from API
    loadAgingData();

    // getPendingMaterialRequests();
    loadWarehouseData();
    loadUtilizationData();
    loadFastMovingRMItems();
    loadFastMovingFGItems();
    loadMovementRMData();
    loadMovementFGData();
    loadPurchaseOrderRecords();
    loadTopTenCustomers();
    fetchDeliveryProgressRM();
    fetchDeliveryProgressFG();
  }, []);

  // Helper function to shuffle array
  function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  // Color themes list
  const colorThemes = [
    {
      titleColor: "#7fffa2",
      iconBg: "linear-gradient(135deg, #7fffa2 0%, #1890ff 100%)",
      accentColor: "#7fffa2",
      subtitleColor: "#7fffa2",
    },
    {
      titleColor: "#ffa07a",
      iconBg: "linear-gradient(135deg, #ffa07a 0%, #20b2aa 100%)",
      accentColor: "#ffa07a",
      subtitleColor: "#ffa07a",
    },
    {
      titleColor: "#ffb347",
      iconBg: "linear-gradient(135deg, #ffb347 0%, #ffcc33 100%)",
      accentColor: "#ffb347",
      subtitleColor: "#ffb347",
    },
    {
      titleColor: "#d291bc",
      iconBg: "linear-gradient(135deg, #d291bc 0%, #957dad 100%)",
      accentColor: "#d291bc",
      subtitleColor: "#d291bc",
    },
  ];

  const shuffledThemes = shuffleArray(colorThemes);

  function mapOrderStageToStatus(orderStage) {
    switch (orderStage) {
      case "OPEN":
      case "UPDATE":
        return "Open";
      case "VERIFICATION":
        return "Verification";
      case "PREPARE":
        return "Prepare";
      case "READY":
        return "Ready";
      case "ASSIGNED":
        return "Assigned";
      case "PROCESSING":
        return "Processing";
      default:
        return "Open";
    }
  }

  const fetchDeliveryProgressRM = () => {
    setDeliveryProgressRMLoading(true);
    materialRequestService
      .searchSummary(
        `?orderStages=OPEN,UPDATE,VERIFICATION,PREPARE,READY,ASSIGNED,PROCESSING&stockClassId=${rmClassId}`
      )
      .then((data) => {
        const deliveries = (data.content || []).map((mrn) => {
          const hours = moment().diff(moment(mrn.requestDate), "hours");
          return {
            mrn: mrn.requestNumber,
            timeStatus: `${hours} hr over`,
            currentStatus: mapOrderStageToStatus(mrn.orderStage),
          };
        });
        setDeliveryProgressRMData(deliveries);
        setDeliveryProgressRMLoading(false);
      })
      .catch(() => setDeliveryProgressRMLoading(false));
  };
  const fetchDeliveryProgressFG = () => {
    setDeliveryProgressFGLoading(true);
    materialRequestService
      .searchSummary(
        `?orderStages=OPEN,UPDATE,VERIFICATION,PREPARE,READY,ASSIGNED,PROCESSING&stockClassId=${fgClassId}`
      )
      .then((data) => {
        const deliveries = (data.content || []).map((mrn) => {
          const hours = moment().diff(moment(mrn.requestDate), "hours");
          return {
            mrn: mrn.requestNumber,
            timeStatus: `${hours} hr over`,
            currentStatus: mapOrderStageToStatus(mrn.orderStage),
          };
        });
        setDeliveryProgressFGData(deliveries);
        setDeliveryProgressFGLoading(false);
      })
      .catch(() => setDeliveryProgressFGLoading(false));
  };

  const loadUtilizationData = (storeLocationIds) => {
    // Simulate warehouse utilization data
    const utilizationChartData = {
      labels: ["Occupied", "Available", "Reserved"],
      datasets: [
        {
          data: [65, 25, 10],
          backgroundColor: [
            "rgba(255, 99, 132, 0.8)",
            "rgba(54, 162, 235, 0.8)",
            "rgba(255, 205, 86, 0.8)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 205, 86, 1)",
          ],
          borderWidth: 1,
        },
      ],
    };

    setUtilizationData(utilizationChartData);
  };

  const loadFastMovingRMItems = () => {
    setFastMovingRMItemsLoading(true);
    dashboardService
      .getFastMovingItems(`?stockClassId=${rmClassId}`)
      .then((data) => {
        setFastMovingRMItems(data.content || []);
        setFastMovingRMItemsLoading(false);
      })
      .catch(() => setFastMovingRMItemsLoading(false));
  };

  const loadFastMovingFGItems = () => {
    setFastMovingFGItemsLoading(true);
    dashboardService
      .getFastMovingItems(`?stockClassId=${fgClassId}`)
      .then((data) => {
        setFastMovingFGItems(data.content || []);
        setFastMovingFGItemsLoading(false);
      })
      .catch(() => setFastMovingFGItemsLoading(false));
  };

  const loadPurchaseOrderRecords = () => {
    setPurchaseOrderRecordsLoading(true);
    purchaseOrderService
      .getPurchaseOrderRecords()
      .then((data) => {
        // const purchaseOrderStages = (data.content || []).map((record) => ({
        //   label: record.orderNumber,
        //   currentValue: record.completedQuantity,
        //   netValue: record.remainingQuantity,
        //   date: moment(record.orderDate).format("MMM DD"),
        // }));
        // console.log("Setting purchase order records:", purchaseOrderStages);

        const purchaseOrderStages = (data.content || []).map((record) => ({
          orderNumber: record.orderNumber || "N/A",
          orderStatus: record.orderStatus.name || "",
          orderedQuantity: record.orderedQuantity || 0,
          completedQuantity: record.completedQuantity || 0,
          remainingQuantity: record.remainingQuantity || 0,
          orderDate: moment(record.orderDate).format("MMM DD YYYY"),
          expectedDate: moment(record.expectedDate).format("MMM DD YYYY"),
          // buyer:record.buyer.name || "N/A",
          consignee:record.consignee.name || "N/A",
        }));

        setPurchaseOrderRecords(purchaseOrderStages);
        setPurchaseOrderRecordsLoading(false);
      })
      .catch(() => setPurchaseOrderRecordsLoading(false));
  };

  const loadLowStockItems = (storeLocationIds) => {
    // Simulate low stock items
    setLowStockItems([
      {
        key: "1",
        item: "Raw Material X",
        currentStock: 50,
        minStock: 100,
        supplier: "Supplier A",
        status: "critical",
      },
      {
        key: "2",
        item: "Component Y",
        currentStock: 75,
        minStock: 80,
        supplier: "Supplier B",
        status: "warning",
      },
      {
        key: "3",
        item: "Material Z",
        currentStock: 30,
        minStock: 50,
        supplier: "Supplier C",
        status: "critical",
      },
    ]);
  };

  const loadWarehouseData = () => {
    setLoading(true);

    // Load warehouse summary data
    materialDetailService
      .getDailyStat()
      .then((data) => {
        if (data && data.content) {
          setWarehouseSummary(data.content);
        } else {
          setWarehouseSummary({});
        }
      })
      .catch((error) => {
        setError(error);
        setWarehouseSummary({});
      });

    // Load company warehouse data
    companyService
      .getSuggestion("?companyType=STORE")
      .then((x) => {
        if (x && x.content && x.content.length === 1) {
          let companyId = Auth.getProfile().comp_id
            ? Auth.getProfile().comp_id
            : x.content[0].id;
          companyService
            .getById(companyId)
            .then((data) => {
              if (data && data.content && data.content.addresses) {
                const storeLocationAddresses = data.content.addresses.filter(
                  (item) => item.addressType === "WAREHOUSE"
                );
                const locationIds = storeLocationAddresses
                  .map((item) => item.id)
                  .join();
                // loadStockData(locationIds);
                // loadMovementData(locationIds);
                loadUtilizationData(locationIds);
                // loadRecentActivities(locationIds);
                loadLowStockItems(locationIds);
              } else {
                // If no addresses found, still load with empty data
                // loadStockData("");
                // loadMovementData("");
                loadUtilizationData("");
                // loadRecentActivities("");
                loadLowStockItems("");
              }
            })
            .catch((error) => {
              // Load with empty data on error
              // loadStockData("");
              // loadMovementData("");
              loadUtilizationData("");
              // loadRecentActivities("");
              loadLowStockItems("");
            });
        } else {
          // If no companies found, load with empty data
          // loadStockData("");
          // loadMovementData("");
          loadUtilizationData("");
          // loadRecentActivities("");
          loadLowStockItems("");
        }
      })
      .catch((error) => {
        // Load with empty data on error
        // loadStockData("");
        // loadMovementData("");
        loadUtilizationData("");
        // loadRecentActivities("");
        loadLowStockItems("");
      });
  };

  const loadStockData = (storeLocationIds) => {
    let searchParams = `?fromDate=${encodeURIComponent(
      moment("2021-01-01").format("YYYY-MM-DD")
    )}&toDate=${moment().format(
      "YYYY-MM-DD"
    )}&storeLocations=${storeLocationIds}`;

    reportService
      .getAvailableStocks(searchParams)
      .then((data) => {
        if (data && data.content && data.content.length > 0) {
          const stockTypes = data.content.map(
            (item) => item.stockType || "Unknown"
          );
          const quantities = data.content.map((item) => item.quantity || 30);
          const netWeights = data.content.map((item) => item.netWeight || 80);

          setStockChartData({
            labels: stockTypes,
            datasets: [
              {
                label: "Quantity",
                backgroundColor: "rgba(54, 162, 235, 0.8)",
                borderColor: "rgba(54, 162, 235, 1)",
                data: quantities,
              },
              {
                label: "Net Weight (Kg)",
                backgroundColor: "rgba(255, 99, 132, 0.8)",
                borderColor: "rgba(255, 99, 132, 1)",
                data: netWeights,
              },
            ],
          });
        } else {
          // Set default empty data if no data is available
          setStockChartData({
            labels: ["No Data"],
            datasets: [
              {
                label: "Quantity",
                backgroundColor: "rgba(54, 162, 235, 0.8)",
                borderColor: "rgba(54, 162, 235, 1)",
                data: [0],
              },
              {
                label: "Net Weight (Kg)",
                backgroundColor: "rgba(255, 99, 132, 0.8)",
                borderColor: "rgba(255, 99, 132, 1)",
                data: [0],
              },
            ],
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        // Set default empty data on error
        setStockChartData({
          labels: ["No Data"],
          datasets: [
            {
              label: "Quantity",
              backgroundColor: "rgba(54, 162, 235, 0.8)",
              borderColor: "rgba(54, 162, 235, 1)",
              data: [0],
            },
            {
              label: "Net Weight (Kg)",
              backgroundColor: "rgba(255, 99, 132, 0.8)",
              borderColor: "rgba(255, 99, 132, 1)",
              data: [0],
            },
          ],
        });
        setLoading(false);
      });
  };

  const loadTopTenCustomers = () => {
    setTopTenCustomersLoading(true);

    dashboardService.getTopTenCustomers().then((data) => {
      if (data && data.content && data.content.length > 0) {
        // Extract real customers
        const customers = data.content.map(
          (item) => item.customerName || "Unknown"
        );

        const quantities = data.content.map(
          (item) => item.totalPurchaseValue || 0
        );

        setTopTenCustomers({
          labels: customers,
          datasets: [
            {
              label: "Customers",
              backgroundColor: "rgba(54, 162, 235, 0.8)",
              borderColor: "rgba(54, 162, 235, 1)",
              data: quantities,
            },
          ],
        });
        setTopTenCustomersLoading(false);
      }

      setLoading(false);
    });
  };

  const loadMovementFGData = () => {
    setLoadingMovementChartFGData(true);
    reportService
      .getStockInOutSummary(
        `?fromDate=2025-07-01&toDate=2025-07-30&stockClassId=${fgClassId}`
      )
      .then((data) => {
        // Group by date and type
        const summary = {};
        (data.content || []).forEach((item) => {
          const date = moment(item.invoiceDate).format("MMM DD");
          if (!summary[date])
            summary[date] = {
              IN: 0,
              OUT: 0,
              IN_INVOICES: [],
              OUT_INVOICES: [],
            };
          if (item.type === "IN") {
            summary[date].IN += item.totalItems || 0;
            summary[date].IN_INVOICES.push(item.invoiceNumber || "");
          }
          if (item.type === "OUT") {
            summary[date].OUT += item.totalItems || 0;
            summary[date].OUT_INVOICES.push(item.invoiceNumber || "");
          }
        });

        // Sort dates
        const days = Object.keys(summary).sort(
          (a, b) => moment(a, "MMM DD") - moment(b, "MMM DD")
        );
        const inMovements = days.map((date) => summary[date].IN);
        const outMovements = days.map((date) => summary[date].OUT);
        // For each day, join all invoice numbers for that day/type (comma separated)
        const inInvoiceNumbers = days.map((date) =>
          summary[date].IN_INVOICES.join(", ")
        );
        const outInvoiceNumbers = days.map((date) =>
          summary[date].OUT_INVOICES.join(", ")
        );

        setMovementChartFGData({
          labels: days,
          datasets: [
            {
              label: "Stock In",
              borderColor: "rgb(75, 192, 192)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              data: inMovements,
              tension: 0.1,
              extraInvoiceNumbers: inInvoiceNumbers,
            },
            {
              label: "Stock Out",
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.2)",
              data: outMovements,
              tension: 0.1,
              extraInvoiceNumbers: outInvoiceNumbers,
            },
          ],
        });
        setLoadingMovementChartFGData(false);
      })
      .catch(() => setLoadingMovementChartFGData(false));
  };

  const loadMovementRMData = () => {
    setLoadingMovementChartRMData(true);
    reportService
      .getStockInOutSummary(
        `?fromDate=2025-07-01&toDate=2025-07-30&stockClassId=${rmClassId}`
      )
      .then((data) => {
        // Group by date and type
        const summary = {};
        (data.content || []).forEach((item) => {
          const date = moment(item.invoiceDate).format("MMM DD");
          if (!summary[date])
            summary[date] = {
              IN: 0,
              OUT: 0,
              IN_INVOICES: [],
              OUT_INVOICES: [],
            };
          if (item.type === "IN") {
            summary[date].IN += item.totalItems || 0;
            summary[date].IN_INVOICES.push(item.invoiceNumber || "");
          }
          if (item.type === "OUT") {
            summary[date].OUT += item.totalItems || 0;
            summary[date].OUT_INVOICES.push(item.invoiceNumber || "");
          }
        });

        // Sort dates
        const days = Object.keys(summary).sort(
          (a, b) => moment(a, "MMM DD") - moment(b, "MMM DD")
        );
        const inMovements = days.map((date) => summary[date].IN);
        const outMovements = days.map((date) => summary[date].OUT);
        // For each day, join all invoice numbers for that day/type (comma separated)
        const inInvoiceNumbers = days.map((date) =>
          summary[date].IN_INVOICES.join(", ")
        );
        const outInvoiceNumbers = days.map((date) =>
          summary[date].OUT_INVOICES.join(", ")
        );

        setMovementChartRMData({
          labels: days,
          datasets: [
            {
              label: "Stock In",
              borderColor: "rgb(75, 192, 192)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              data: inMovements,
              tension: 0.1,
              extraInvoiceNumbers: inInvoiceNumbers,
            },
            {
              label: "Stock Out",
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.2)",
              data: outMovements,
              tension: 0.1,
              extraInvoiceNumbers: outInvoiceNumbers,
            },
          ],
        });
        setLoadingMovementChartRMData(false);
      })
      .catch(() => setLoadingMovementChartRMData(false));
  };
  // Standardized status color mapping
  const getStatusColor = (status) => {
    const colors = {
      AVAILABLE: "#87d068",
      REQUESTED: "#2db7f5",
      ISSUED: "#108ee9",
      DELIVERED: "#f50",
      completed: "#52c41a",
      pending: "#faad14",
      critical: "#f5222d",
      warning: "#faad14",
    };
    return colors[status] || "#999";
  };

  // Standardized activity columns
  const activityColumns = [
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      width: "20%",
      render: (activity) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "500",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: getStatusColor(activity),
            }}
          ></span>
          {activity}
        </div>
      ),
    },
    {
      title: "Item",
      dataIndex: "item",
      key: "item",
      width: "25%",
      render: (item) => (
        <span
          style={{
            color: "#fff",
            fontWeight: "500",
            fontSize: "13px",
          }}
        >
          {item}
        </span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: "15%",
      align: "right",
      render: (quantity) => (
        <span
          style={{
            color: "#1890ff",
            fontWeight: "600",
            fontSize: "13px",
          }}
        >
          {typeof quantity === "number" && quantity != null
            ? quantity.toLocaleString()
            : quantity ?? ""}
        </span>
      ),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      width: "15%",
      render: (time) => (
        <span
          style={{
            color: "#999",
            fontSize: "12px",
            fontStyle: "italic",
          }}
        >
          {time}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
      render: (status) => (
        <div className="activity-status">
          <div
            className="activity-icon"
            style={{
              backgroundColor: getStatusColor(status),
            }}
          >
            {status === "completed" ? "✓" : status === "pending" ? "⏳" : "✗"}
          </div>
          <Tag color={getStatusColor(status)}>{status.toUpperCase()}</Tag>
        </div>
      ),
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      width: "10%",
      render: (user) => (
        <span
          style={{
            color: "#e6e6e6",
            fontWeight: "400",
            fontSize: "13px",
          }}
        >
          {user}
        </span>
      ),
    },
  ];

  // Standardized fast moving items columns
  const fastMovingItemColumns = [
    {
      title: "Material",
      dataIndex: "stockTypeName",
      key: "stockTypeName",
      width: "30%",
      align: "left",
      render: (stockTypeName) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "500",
            textAlign: "left",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#faad14",
              flexShrink: "0",
            }}
          ></span>
          <span style={{ flex: "1", textAlign: "left" }}>{stockTypeName}</span>
        </div>
      ),
    },
    {
      title: "Issue Qty",
      dataIndex: "issueCount",
      key: "issueCount",
      width: "20%",
      align: "center",
      render: (issueCount) => (
        <div
          style={{
            color: "#fff",
            fontWeight: "500",
            fontSize: "13px",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {issueCount}
        </div>
      ),
    },
    // {
    //   title: "Total Issued Quantity",
    //   dataIndex: "totalIssuedQuantity",
    //   key: "totalIssuedQuantity",
    //   width: "25%",
    //   align: "center",
    //   render: (totalIssuedQuantity) => (
    //     <div
    //       style={{
    //         color: "#1890ff",
    //         fontWeight: "600",
    //         fontSize: "13px",
    //         textAlign: "center",
    //         display: "block",
    //         width: "100%",
    //         padding: "0",
    //         margin: "0",
    //       }}
    //     >
    //       {typeof totalIssuedQuantity === "number" &&
    //       totalIssuedQuantity != null
    //         ? totalIssuedQuantity.toLocaleString()
    //         : totalIssuedQuantity ?? ""}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Movement Value",
    //   dataIndex: "totalMovementValue",
    //   key: "totalMovementValue",
    //   width: "25%",
    //   align: "center",
    //   render: (totalMovementValue) => (
    //     <div
    //       style={{
    //         color: "#999",
    //         fontSize: "12px",
    //         fontStyle: "italic",
    //         textAlign: "center",
    //         display: "block",
    //         width: "100%",
    //         padding: "0",
    //         margin: "0",
    //       }}
    //     >
    //       {totalMovementValue}
    //     </div>
    //   ),
    // },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: "25%",
      align: "center",
      render: (price) => (
        <div
          style={{
            color: "#999",
            fontSize: "12px",
            fontStyle: "italic",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {price}
        </div>
      ),
    },
  ];

  // Standardized purchase order process columns
  const purchaseOrderProcessColumns = [
    {
      title: "Order No",
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: "5%",
      align: "left",
      render: (text, record) => (
        <div
          style={{
            color: "#ff9933",
            fontWeight: "600",
            fontSize: "13px",
            textAlign: "left",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: "8%",
      align: "center",
      render: (text) => (
        <div
          style={{
            color: "#fff",
            fontSize: "13px",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Expected Date",
      dataIndex: "expectedDate",
      key: "expectedDate",
      width: "8%",
      align: "center",
      render: (text) => (
        <div
          style={{
            color: "#fff",
            fontSize: "13px",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      key: "consignee",
      width: "18%",
      // align: "right",
      render: (text) => (
        <div
          // style={{
          //   color: "#fff",
          //   fontSize: "13px",
          //   textAlign: "left",
          //   display: "block",
          //   width: "100%",
          //   padding: "0",
          //   margin: "0",
          // }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Com.Qty",
      dataIndex: "completedQuantity",
      key: "completedQuantity",
      width: "10%",
      align: "center",
      render: (text) => (
        <div
          style={{
            color: "#52c41a",
            fontWeight: "600",
            fontSize: "13px",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {typeof text === "number" && text != null
            ? text.toLocaleString()
            : text ?? ""}
        </div>
      ),
    },
    {
      title: "Rem.Qty",
      dataIndex: "remainingQuantity",
      key: "remainingQuantity",
      width: "10%",
      align: "center",
      render: (text) => (
        <div
          style={{
            color: "#1890ff",
            fontWeight: "600",
            fontSize: "13px",
            textAlign: "center",
            display: "block",
            width: "100%",
            padding: "0",
            margin: "0",
          }}
        >
          {typeof text === "number" && text != null
            ? text.toLocaleString()
            : text ?? ""}
        </div>
      ),
    },
    createStatusColumn("orderStatus", "Status", "12%"),
    createProgressColumn("orderProgress", "Order Progress", "14%"),
  ];

  // Responsive breakpoints

  const isTablet = useMediaQuery({ maxWidth: 900 });
  const isNarrow = useMediaQuery({ maxWidth: 1682 });

  return (
    <Page className="warehouse-dashboard" error={error}>
      <Spin tip="Loading..." spinning={loading}>
        <div
          className="wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: isTablet ? "24px 3vw" : "40px 4vw",
            maxWidth: 1920,
            margin: "0 auto",
            gap: 32,
            background: "#181a27",
            borderRadius: 24,
            boxShadow: "0 4px 32px rgba(0,0,0,0.08)",
          }}
        >
          {/* --- Stock Overview Section --- */}
          <DashboardFlexRow
            style={{
              alignItems: "stretch",
              flexWrap: "wrap",
              gap: 24,
              marginBottom: 0,
            }}
          >
            {/* First WidgetCard */}
            {stockClasses[0] && (
              <div
                key={stockClasses[0].id}
                style={{
                  flex: "1 1 280px",
                  minWidth: 220,
                  maxWidth: 400,
                  minHeight: 320,
                  height: 320,
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "stretch",
                }}
              >
                <WidgetCard
                  title={stockClasses[0].name}
                  titleColor={
                    shuffledThemes[0 % shuffledThemes.length].titleColor
                  }
                  icon={
                    <img src={logoIcon} alt="icon" style={{ height: 28 }} />
                  }
                  iconBg={shuffledThemes[0 % shuffledThemes.length].iconBg}
                  accentColor={
                    shuffledThemes[0 % shuffledThemes.length].accentColor
                  }
                  value1={stockClasses[0].totalStorageUnits}
                  subtitle1="Total Pallets"
                  value2={stockClasses[0].totalStocks}
                  subtitle2="Total Packages"
                  valueColor="#fff"
                  subtitleColor={
                    shuffledThemes[0 % shuffledThemes.length].subtitleColor
                  }
                  background="#23263a"
                  style={{
                    flex: 1,
                    minWidth: 0,
                    width: "100%",
                    minHeight: 320,
                    height: 320,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                />
              </div>
            )}
            {/* FINISHED GOOD Apex chart */}
            <Card
              title={
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 20 }}>
                  FINISHED GOOD - Age Breakdown
                </span>
              }
              style={{
                maxWidth: 420,
                flex: 1,
                background: "#23263a",
                borderRadius: 16,
                border: "none",
                minHeight: 320,
                height: 320,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transform: "translateZ(0)", // Force hardware acceleration
                willChange: "auto", // Optimize for changes
              }}
              headStyle={{
                textAlign: "center",
                borderBottom: "none",
                background: "none",
                color: "#fff",
              }}
              bodyStyle={{
                background: "none",
                padding: 0,
                height: "100%",
                display: "flex",
                alignItems: "stretch",
                justifyContent: "stretch",
                overflow: "hidden", // Prevent overflow issues
              }}
            >
              <div
                style={{
                  flex: 1,
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  transform: "translateZ(0)", // Force hardware acceleration
                  overflow: "hidden", // Prevent overflow issues
                }}
              >
                <Spin spinning={loadingAgingData} tip="Loading aging data...">
                  <ApexBreakdownChart
                    key={`finished-good-${agingData.length}`}
                    stockClassName="FINISHED GOOD"
                    agingData={agingData}
                    style={{ height: "100%", width: "100%" }}
                  />
                </Spin>
              </div>
            </Card>
            {/* Second WidgetCard */}
            {stockClasses[1] && (
              <div
                key={stockClasses[1].id}
                style={{
                  flex: "1 1 280px",
                  minWidth: 220,
                  maxWidth: 400,
                  minHeight: 320,
                  height: 320,
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "stretch",
                }}
              >
                <WidgetCard
                  title={stockClasses[1].name}
                  titleColor={
                    shuffledThemes[1 % shuffledThemes.length].titleColor
                  }
                  icon={
                    <img src={logoIcon} alt="icon" style={{ height: 28 }} />
                  }
                  iconBg={shuffledThemes[1 % shuffledThemes.length].iconBg}
                  accentColor={
                    shuffledThemes[1 % shuffledThemes.length].accentColor
                  }
                  value1={stockClasses[1].totalStorageUnits}
                  subtitle1="Total Pallets"
                  value2={stockClasses[1].totalStocks}
                  subtitle2="Total Packages"
                  valueColor="#fff"
                  subtitleColor={
                    shuffledThemes[1 % shuffledThemes.length].subtitleColor
                  }
                  background="#23263a"
                  style={{
                    flex: 1,
                    minWidth: 0,
                    width: "100%",
                    minHeight: 320,
                    height: 320,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                />
              </div>
            )}
            {/* RAW MATERIAL Apex chart */}
            <Card
              title={
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 20 }}>
                  RAW MATERIAL - Age Breakdown
                </span>
              }
              style={{
                maxWidth: 420,
                flex: 1,
                background: "#23263a",
                borderRadius: 16,
                border: "none",
                minHeight: 320,
                height: 320,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transform: "translateZ(0)", // Force hardware acceleration
                willChange: "auto", // Optimize for changes
              }}
              headStyle={{
                textAlign: "center",
                borderBottom: "none",
                background: "none",
                color: "#fff",
              }}
              bodyStyle={{
                background: "none",
                padding: 0,
                height: "100%",
                display: "flex",
                alignItems: "stretch",
                justifyContent: "stretch",
                overflow: "hidden", // Prevent overflow issues
              }}
            >
              <div
                style={{
                  flex: 1,
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  transform: "translateZ(0)", // Force hardware acceleration
                  overflow: "hidden", // Prevent overflow issues
                }}
              >
                <Spin spinning={loadingAgingData} tip="Loading aging data...">
                  <ApexBreakdownChart
                    key={`raw-material-${agingData.length}`}
                    stockClassName="RAW MATERIAL"
                    agingData={agingData}
                    style={{ height: "100%", width: "100%" }}
                  />
                </Spin>
              </div>
            </Card>
          </DashboardFlexRow>

          {/* Additional Stock Classes */}
          {stockClasses.length > 2 && (
            <DashboardFlexRow
              style={{
                alignItems: "stretch",
                flexWrap: "wrap",
                gap: 24,
                marginBottom: 0,
              }}
            >
              {stockClasses.slice(2).map((summary, i) => {
                const theme = shuffledThemes[(i + 2) % shuffledThemes.length];
                return (
                  <div
                    key={summary.id}
                    style={{
                      flex: "1 1 280px",
                      minWidth: 220,
                      maxWidth: 400,
                      minHeight: 320,
                      height: 320,
                      boxSizing: "border-box",
                      display: "flex",
                      alignItems: "stretch",
                    }}
                  >
                    <WidgetCard
                      title={summary.name}
                      titleColor={theme.titleColor}
                      icon={
                        <img src={logoIcon} alt="icon" style={{ height: 28 }} />
                      }
                      iconBg={theme.iconBg}
                      accentColor={theme.accentColor}
                      value1={summary.totalStorageUnits}
                      subtitle1="Total Pallets"
                      value2={summary.totalStocks}
                      subtitle2="Total Packages"
                      valueColor="#fff"
                      subtitleColor={theme.subtitleColor}
                      background="#23263a"
                      style={{
                        flex: 1,
                        minWidth: 0,
                        width: "100%",
                        minHeight: 320,
                        height: 320,
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                      }}
                    />
                  </div>
                );
              })}
            </DashboardFlexRow>
          )}

          {/* --- Order & Delivery Section --- */}
          <DashboardFlexRow
            style={{
              alignItems: "stretch",
              flexWrap: "nowrap",
              gap: 24,
              marginBottom: 0,
            }}
          >
            <div
              style={{
                flex: 1,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={deliveryProgressFGLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#7fffa2",
                        }}
                      >
                        <FaTruck
                          className="delivery-progress-icon"
                          style={{ marginRight: 8 }}
                        />
                      </span>
                      Delivery Progress - FG
                    </span>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minHeight: 450,
                      maxHeight: 450,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DeliveryProgress deliveries={deliveryProgressFGData} />
                  </div>
                </div>
              </Spin>
            </div>
            <div
              style={{
                flex: 1,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={deliveryProgressRMLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#7fffa2",
                        }}
                      >
                        <FaTruck
                          className="delivery-progress-icon"
                          style={{ marginRight: 8 }}
                        />
                      </span>
                      Delivery Progress - RM
                    </span>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minHeight: 450,
                      maxHeight: 450,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DeliveryProgress deliveries={deliveryProgressRMData} />
                  </div>
                </div>
              </Spin>
            </div>
            {/* <div style={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'stretch', boxSizing: 'border-box' }}>
              <Spin spinning={purchaseOrderRecordsLoading} tip="Loading...">
                <div
                  style={{
                    background: '#23263a',
                    borderRadius: 16,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: 'hidden',
                    border: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 600,
                      fontSize: '1.5rem',
                      color: '#fff',
                      background: 'linear-gradient(90deg, #1e2235 60%, #23263a 100%)',
                      borderBottom: '1px solid #23263a',
                      padding: '0 16px',
                      height: 56
                    }}
                  >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: 22, color: '#ffe066' }}>
                        <FaClipboardList style={{ marginRight: 8 }} />
                      </span>
                      PO Process
                    </span>
                  </div>
                  <div style={{ flex: 1, minHeight: 300, maxHeight: 300, height: 300, padding: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <StandardTable
                      dataSource={purchaseOrderRecords}
                      columns={purchaseOrderProcessColumns}
                      loading={false}
                      scroll={{ y: 220 }}
                    />
                  </div>
                </div>
              </Spin>
            </div> */}
          </DashboardFlexRow>

          <DashboardFlexRow
            style={{
              alignItems: "stretch",
              flexWrap: "nowrap",
              gap: 24,
              marginBottom: 0,
            }}
          >
            <div
              style={{
                flex: 1,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={purchaseOrderRecordsLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#ffe066",
                        }}
                      >
                        <FaClipboardList style={{ marginRight: 8 }} />
                      </span>
                      PO Progress
                    </span>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minHeight: 300,
                      maxHeight: 300,
                      height: 300,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StandardTable
                      dataSource={purchaseOrderRecords}
                      columns={purchaseOrderProcessColumns}
                      loading={false}
                      scroll={{ y: 220 }}
                    />
                  </div>
                </div>
              </Spin>
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 220,
                maxWidth: 400,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  background: "#23263a",
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  marginTop: 0,
                  marginBottom: 0,
                  padding: 0,
                  overflow: "hidden",
                  border: "none",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    minHeight: 48,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    fontSize: "1.5rem",
                    color: "#fff",
                    background:
                      "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                    borderBottom: "1px solid #23263a",
                    padding: "0 16px",
                    height: 56,
                  }}
                >
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        fontSize: 22,
                        color: "#7fffa2",
                      }}
                    >
                      <FaWarehouse style={{ marginRight: 8 }} />
                    </span>
                    Warehouse Utilization
                  </span>
                </div>
                <div
                  className="chart-container"
                  style={{
                    width: "100%",
                    height: "100%",
                    boxSizing: "border-box",
                    flex: 1,
                    padding: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="chart-inner" style={{ height: "100%" }}>
                    {utilizationData &&
                    utilizationData.labels &&
                    utilizationData.labels.length > 0 ? (
                      <Doughnut
                        data={utilizationData}
                        options={doughnutOptions}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <span style={{ color: "#aaa" }}>No data</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DashboardFlexRow>

          {/* --- Warehouse Insights Section --- */}
          <DashboardFlexRow
            style={{ alignItems: "stretch", flexWrap: "wrap", gap: 24 }}
          >
            <div
              style={{
                flex: 2,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={fastMovingFGItemsLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#ffe066",
                        }}
                      >
                        <FaClipboardList style={{ marginRight: 8 }} />
                      </span>
                      Fast Moving - FG
                    </span>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minHeight: 300,
                      maxHeight: 300,
                      height: 300,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StandardTable
                      dataSource={fastMovingFGItems}
                      columns={fastMovingItemColumns}
                      loading={false}
                      scroll={{ y: 220 }}
                    />
                  </div>
                </div>
              </Spin>
            </div>
            <div
              style={{
                flex: 2,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={fastMovingRMItemsLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#ffe066",
                        }}
                      >
                        <FaClipboardList style={{ marginRight: 8 }} />
                      </span>
                      Fast Moving - RM
                    </span>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minHeight: 300,
                      maxHeight: 300,
                      height: 300,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StandardTable
                      dataSource={fastMovingRMItems}
                      columns={fastMovingItemColumns}
                      loading={false}
                      scroll={{ y: 220 }}
                    />
                  </div>
                </div>
              </Spin>
            </div>
          </DashboardFlexRow>

          {/* --- Additional Insights Section --- */}
          <DashboardFlexRow
            style={{ alignItems: "stretch", flexWrap: "wrap", gap: 24 }}
          >
            <div
              style={{
                flex: 1,
                minWidth: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <Spin spinning={topTenCustomersLoading} tip="Loading...">
                <div
                  style={{
                    background: "#23263a",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    overflow: "hidden",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      minHeight: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: "1.5rem",
                      color: "#fff",
                      background:
                        "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                      borderBottom: "1px solid #23263a",
                      padding: "0 16px",
                      height: 56,
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 22,
                          color: "#7fffa2",
                        }}
                      >
                        <FaUsers style={{ marginRight: 8 }} />
                      </span>
                      Top 10 Consignees
                    </span>
                  </div>
                  <div
                    className="chart-inner"
                    style={{
                      height: "100%",
                      flex: 1,
                      padding: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <TopCustomersGrid topTenCustomers={topTenCustomers} />
                  </div>
                </div>
              </Spin>
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 300,
                maxWidth: 850,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
                background: "#23263a",
                borderRadius: 16,
                marginTop: 0,
                marginBottom: 0,
                padding: 0,
                overflow: "hidden",
                border: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  minHeight: 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                  color: "#fff",
                  background:
                    "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                  borderBottom: "1px solid #23263a",
                  padding: "0 16px",
                  height: 56,
                }}
              >
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      fontSize: 22,
                      color: "#7fffa2",
                    }}
                  >
                    <FaChartLine style={{ marginRight: 8 }} />
                  </span>
                  Stock Movement Trend - FG
                </span>
              </div>
              <Spin spinning={loadingMovementChartFGData} tip="Loading...">
                <div
                  style={{
                    flex: 1,
                    minHeight: 244,
                    padding: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {movementChartFGData &&
                  movementChartFGData.labels &&
                  movementChartFGData.labels.length > 0 ? (
                    <Line data={movementChartFGData} options={lineOptions} />
                  ) : (
                    <span style={{ color: "#aaa" }}>No data</span>
                  )}
                </div>
              </Spin>
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 300,
                maxWidth: 850,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
                background: "#23263a",
                borderRadius: 16,
                marginTop: 0,
                marginBottom: 0,
                padding: 0,
                overflow: "hidden",
                border: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  minHeight: 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                  color: "#fff",
                  background:
                    "linear-gradient(90deg, #1e2235 60%, #23263a 100%)",
                  borderBottom: "1px solid #23263a",
                  padding: "0 16px",
                  height: 56,
                }}
              >
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      fontSize: 22,
                      color: "#7fffa2",
                    }}
                  >
                    <FaChartLine style={{ marginRight: 8 }} />
                  </span>
                  Stock Movement Trend - RM
                </span>
              </div>
              <Spin spinning={loadingMovementChartRMData} tip="Loading...">
                <div
                  style={{
                    flex: 1,
                    minHeight: 244,
                    padding: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {movementChartRMData &&
                  movementChartRMData.labels &&
                  movementChartRMData.labels.length > 0 ? (
                    <Line data={movementChartRMData} options={lineOptions} />
                  ) : (
                    <span style={{ color: "#aaa" }}>No data</span>
                  )}
                </div>
              </Spin>
            </div>
          </DashboardFlexRow>
        </div>
      </Spin>
    </Page>
  );
}

export default Home;

// Pie chart component for stock class summary
function PieChartByStockClass({ data }) {
  if (!Array.isArray(data)) return null;
  return (
    <div
      style={{
        display: "flex",
        gap: 32,
        justifyContent: "center",
        margin: "24px 0",
      }}
    >
      {data
        .filter(
          (stockClass) =>
            stockClass &&
            typeof stockClass.stockClassName === "string" &&
            stockClass.stockClassName.trim() !== ""
        )
        .map((stockClass, idx) => (
          <div
            key={stockClass.stockClassName || idx}
            style={{
              minWidth: 220,
              maxWidth: 320,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#fff",
                fontWeight: 700,
                fontSize: 18,
                marginBottom: 8,
              }}
            >
              {stockClass.stockClassName}
            </div>
            <div
              className="chart-container"
              style={{
                width: "100%",
                height: 180,
                background: "none",
                boxShadow: "none",
                border: "none",
              }}
            >
              <Doughnut
                data={{
                  labels: [
                    "< 90 days",
                    "90-180 days",
                    "180-270 days",
                    "270-360 days",
                    "> 360 days",
                  ],
                  datasets: [
                    {
                      data: [
                        stockClass.sumAgeLt90 || 0,
                        stockClass.sumAge90To180 || 0,
                        stockClass.sumAge180To270 || 0,
                        stockClass.sumAge270To360 || 0,
                        stockClass.sumAgeGt360 || 0,
                      ],
                      backgroundColor: [
                        "#7fffa2", // < 90 days
                        "#ffe066", // 90-180 days
                        "#ff9800", // 180-270 days
                        "#d32f2f", // 270-360 days
                        "#1976d2", // > 360 days
                      ],
                      borderColor: "#23263a",
                      borderWidth: 2,
                      hoverOffset: 16,
                      hoverBorderColor: "#fff",
                      hoverBorderWidth: 4,
                    },
                  ],
                }}
                options={{
                  plugins: {
                    legend: {
                      display: true,
                      position: "bottom",
                      labels: {
                        color: "#fff",
                        usePointStyle: true,
                        pointStyle: "rectRounded",
                      },
                    },
                  },
                  cutout: "70%",
                  responsive: true,
                  maintainAspectRatio: false,
                }}
              />
            </div>
          </div>
        ))}
    </div>
  );
}

// Apex Pie Chart sample
function ApexBreakdownChart({ stockClassName, agingData }) {
  // Check if mobile device
  const isMobile = window.innerWidth <= 768;

  // Hide charts completely on mobile
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: 340,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "16px",
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "8px",
        }}
      >
        Charts not available on mobile devices
      </div>
    );
  }

  // Find the stock class by name from API data
  const stockClass = (agingData || []).find(
    (item) => item.stockClassName === stockClassName
  );
  // If not found, fallback to FINISHED GOOD
  const fallback = (agingData || []).find(
    (item) => item.stockClassName === "FINISHED GOOD"
  );
  const dataObj = stockClass || fallback;

  // If no data available, show a message
  if (!dataObj) {
    return (
      <div
        style={{
          width: "100%",
          height: 340,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "16px",
        }}
      >
        No data available for {stockClassName}
      </div>
    );
  }

  const breakdownFields = [
    { key: "totalItems", label: "Total Items" },
    { key: "sumAgeLt90", label: "< 90 days" },
    { key: "sumAge90To180", label: "90-180 days" },
    { key: "sumAge180To270", label: "180-270 days" },
    { key: "sumAge270To360", label: "270-360 days" },
    { key: "sumAgeGt360", label: "> 360 days" },
  ];

  const series = breakdownFields.map((f) =>
    dataObj ? dataObj[f.key] || 0 : 0
  );
  const labels = breakdownFields.map((f) => f.label);

  return (
    <div
      style={{
        width: "100%",
        height: 280,
        position: "relative",
        overflow: "hidden", // Prevent overflow issues
      }}
    >
      <ReactApexChart
        options={{
          chart: {
            type: "pie",
            animations: {
              enabled: false, // Disable animations to prevent ResizeObserver issues
            },
            redrawOnWindowResize: false, // Prevent redraw on resize
            redrawOnParentResize: false, // Prevent redraw on parent resize
            toolbar: {
              show: false, // Disable toolbar to reduce complexity
            },
            zoom: {
              enabled: false, // Disable zoom to prevent resize issues
            },
            selection: {
              enabled: false, // Disable selection to prevent resize issues
            },
            events: {
              // Disable all chart events that might cause resize issues
              beforeMount: undefined,
              mounted: undefined,
              updated: undefined,
              click: undefined,
              legendClick: undefined,
              markerClick: undefined,
              selection: undefined,
              dataPointSelection: undefined,
              dataPointMouseEnter: undefined,
              dataPointMouseLeave: undefined,
              beforeZoom: undefined,
              beforeResetZoom: undefined,
              zoomed: undefined,
              scrolled: undefined,
              brushScrolled: undefined,
            },
            // Completely disable ResizeObserver functionality
            sparkline: {
              enabled: false,
            },
            brush: {
              enabled: false,
            },
            selection: {
              enabled: false,
            },
            zoom: {
              enabled: false,
            },
            pan: {
              enabled: false,
            },
          },
          labels,

          legend: {
            labels: {
              colors: "#fff",
              fontSize: "14px",
            },
            position: "bottom",
            horizontalAlign: "center",
          },
          plotOptions: {
            pie: {
              donut: {
                size: "60%",
              },
              offsetY: 10,
            },
          },
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
            active: {
              filter: {
                type: "none",
              },
            },
          },
        }}
        series={series}
        type="pie"
        width="100%"
        height={280}
      />
    </div>
  );
}

// Apex Pie Chart widget for a given stock class
function ApexChartWidget({ stockClassName, agingData }) {
  const stockClass = (agingData || []).find(
    (item) => item.stockClassName === stockClassName
  );
  if (!stockClass)
    return (
      <div style={{ color: "#fff", textAlign: "center", margin: 16 }}>
        No data for {stockClassName}
      </div>
    );
  const breakdownFields = [
    { key: "totalItems", label: "Total Items" },
    { key: "sumAgeLt90", label: "Age < 90" },
    { key: "sumAge90To180", label: "90 ≤ Age < 180" },
    { key: "sumAge180To270", label: "180 ≤ Age < 270" },
    { key: "sumAge270To360", label: "270 ≤ Age < 360" },
    { key: "sumAgeGt360", label: "Age ≥ 360" },
  ];
  const series = breakdownFields.map((f) => stockClass[f.key] || 0);
  const labels = breakdownFields.map((f) => f.label);
  const options = {
    chart: { width: 380, type: "pie" },
    labels,
    legend: { labels: { colors: "#fff" } },
  };
  return (
    <div style={{ width: "100%", minHeight: 320 }}>
      <ReactApexChart
        options={options}
        series={series}
        type="pie"
        width={"100%"}
      />
    </div>
  );
}

function ApexChartWidgets({ agingData }) {
  // Check if mobile device
  const isMobile = window.innerWidth <= 768;

  // Hide charts completely on mobile
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: 320,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "16px",
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "8px",
          margin: "32px 0",
        }}
      >
        Charts not available on mobile devices
      </div>
    );
  }

  // Find FINISHED GOOD and RAW MATERIAL stock classes
  const finishedGood = (agingData || []).find(
    (item) => item.stockClassName === "FINISHED GOOD"
  );
  let rawMaterial = (agingData || []).find(
    (item) => item.stockClassName === "RAW MATERIAL"
  );
  // If RAW MATERIAL does not exist, use FINISHED GOOD data for both
  if (!rawMaterial) rawMaterial = finishedGood;

  // Fields to show in the breakdown
  const breakdownFields = [
    { key: "totalItems", label: "Total Items" },
    { key: "sumAgeLt90", label: "< 90 days" },
    { key: "sumAge90To180", label: "90-180 days" },
    { key: "sumAge180To270", label: "180-270 days" },
    { key: "sumAge270To360", label: "270-360 days" },
    { key: "sumAgeGt360", label: "> 360 days" },
  ];

  function getSeriesAndLabels(stockClass) {
    if (!stockClass) return { series: [], labels: [] };
    return {
      series: breakdownFields.map((f) => stockClass[f.key] || 0),
      labels: breakdownFields.map((f) => f.label),
    };
  }

  const fgData = getSeriesAndLabels(finishedGood);
  const rmData = getSeriesAndLabels(rawMaterial);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 32,
        justifyContent: "center",
        margin: "32px 0",
      }}
    >
      <Card
        title={
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 20 }}>
            FINISHED GOOD - Age Breakdown
          </span>
        }
        style={{
          maxWidth: 420,
          flex: 1,
          background: "#23263a",
          borderRadius: 16,
          border: "none",
        }}
        headStyle={{ background: "#23263a", border: "none" }}
        bodyStyle={{ background: "#23263a", border: "none" }}
      >
        <ReactApexChart
          options={{
            chart: {
              type: "pie",
              background: "none",
              animations: {
                enabled: false,
              },
              redrawOnWindowResize: false,
              redrawOnParentResize: false,
            },
            labels: fgData.labels,
            legend: {
              labels: { colors: "#fff" },
              position: "bottom",
            },
          }}
          series={fgData.series}
          type="pie"
          width="100%"
        />
      </Card>
      <Card
        title={
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 20 }}>
            RAW MATERIAL - Age Breakdown
          </span>
        }
        style={{
          maxWidth: 420,
          flex: 1,
          background: "#23263a",
          borderRadius: 16,
          border: "none",
        }}
        headStyle={{ background: "#23263a", border: "none" }}
        bodyStyle={{ background: "#23263a", border: "none" }}
      >
        <ReactApexChart
          options={{
            chart: {
              type: "pie",
              background: "none",
              animations: {
                enabled: false,
              },
              redrawOnWindowResize: false,
              redrawOnParentResize: false,
            },
            labels: rmData.labels,
            legend: {
              labels: { colors: "#fff" },
              position: "bottom",
            },
          }}
          series={rmData.series}
          type="pie"
          width="100%"
        />
      </Card>
    </div>
  );
}
